var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 23.75L11.1413 17.8631C14.2984 15.7122 15.7016 15.7122 18.8587 17.8631L27.5 23.75",
    stroke: "#EDA92B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5199 18.1887C2.60232 21.9804 2.64355 23.8761 4.05763 25.2801C5.47172 26.6841 7.43978 26.7327 11.3759 26.8301C13.7991 26.89 16.2009 26.89 18.6241 26.8301C22.5602 26.7327 24.5282 26.6841 25.9424 25.2801C27.3565 23.8761 27.3976 21.9804 27.4801 18.1887C27.5205 16.3311 27.4994 14.4918 27.4167 12.6151C27.3655 11.4496 27.3399 10.8668 27.0442 10.3498C26.7486 9.83285 26.2391 9.49919 25.22 8.83187L20.519 5.75357C17.8427 4.0012 16.5047 3.125 15 3.125C13.4952 3.125 12.1572 4.00119 9.48103 5.75357L4.77996 8.83187C3.76086 9.49919 3.25132 9.83285 2.95573 10.3498C2.66015 10.8668 2.6345 11.4496 2.5832 12.6151C2.50061 14.4918 2.47951 16.3311 2.5199 18.1887Z",
    stroke: "#EDA92B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 11.875L22.1683 15.759C20.8755 16.7007 19.813 17.5 18.125 17.5M2.5 11.875L7.83172 15.759C9.12444 16.7007 10.187 17.5 11.875 17.5",
    stroke: "#EDA92B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7e0540ca2a351bbc42734319e8916eb9.svg";
export { ForwardRef as ReactComponent };